import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogRef,
  HeadingComponent,
} from '@core/user-interface-legacy';

export type DialogResult = {
  createJob: boolean;
};

export type RequisitionApprovedDialogData = {
  canCreateJob: boolean;
  hasAccessToJob: boolean;
  requisitionName: string;
  offerSlug: string | null;
};

@Component({
  selector: 'rt-requisition-approved-success-dialog',
  templateUrl: './requisition-approved-success-dialog.component.html',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    HeadingComponent,
    RouterModule,
    TranslatePipe,
  ],
})
export class RequisitionApprovedSuccessDialogComponent implements DialogComponentI<
  RequisitionApprovedDialogData,
  DialogResult
> {
  private readonly dialogRef = inject(DialogRef);
  private readonly cdRef = inject(ChangeDetectorRef);

  public readonly imageSrc = 'assets/images/requisitions/approved.svg';
  public canCreateJob: boolean;
  public requisitionName: string;
  public isJobAlreadyCreated: boolean;
  public hasAccessToJob: boolean;
  public offerSlug: string | null;

  public close() {
    this.dialogRef.close();
  }

  public createJob() {
    this.dialogRef.close({ createJob: true });
  }

  public setDialogData(data: RequisitionApprovedDialogData, triggerUpdate: boolean): void {
    this.canCreateJob = data.canCreateJob;
    this.requisitionName = data.requisitionName;
    this.isJobAlreadyCreated = !!data.offerSlug;
    this.hasAccessToJob = data.hasAccessToJob;
    this.offerSlug = data.offerSlug;
    this.cdRef.detectChanges();
  }
}
